export default __webpack_public_path__ + "static/media/Warlord's Mark of Loathing.f0a3e82f.jpg";